export enum NoConsentOption {
  ReadText = 'readText',
  Redirect = 'redirect',
  Ticket = 'ticket',
}
